import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import { IMAGES } from "../config";
import { useLang } from "../LanguageContext";
import { Reveal, Eyebrow } from "./Reveal";

export const Manifesto = () => {
  const { t } = useLang();
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-8%", "8%"]);

  return (
    <section ref={ref} data-testid="manifesto" className="relative py-28 md:py-40 overflow-hidden bg-[#080808]">
      <motion.div style={{ y }} className="absolute inset-0 z-0 opacity-25">
        <img src={IMAGES.manifesto} alt="Abstract luxury texture" className="w-full h-[116%] object-cover" />
        <div className="absolute inset-0 bg-[#050505]/70" />
      </motion.div>

      <div className="relative z-10 max-w-[1400px] mx-auto px-5 md:px-10">
        <div className="max-w-2xl mb-20">
          <Reveal><Eyebrow testId="manifesto-eyebrow">{t.manifesto.eyebrow}</Eyebrow></Reveal>
          <Reveal delay={0.1}>
            <h2 className="font-display text-4xl md:text-6xl text-white tracking-tight leading-[1.05]">
              {t.manifesto.title1} <span className="text-gold-gradient italic">{t.manifesto.title2}</span>
            </h2>
          </Reveal>
        </div>

        <div className="space-y-0">
          {t.manifesto.items.map((m, i) => (
            <Reveal key={i} delay={i * 0.08}>
              <div
                data-testid={`manifesto-${i}`}
                className="group grid grid-cols-1 md:grid-cols-12 gap-6 py-10 border-t border-white/10 hover:border-[#d4af37]/40 transition-colors duration-500"
              >
                <div className="md:col-span-2 font-display text-5xl md:text-6xl text-white/15 group-hover:text-[#d4af37]/60 transition-colors duration-500">{m.n}</div>
                <h3 className="md:col-span-4 font-display text-2xl md:text-3xl text-white">{m.title}</h3>
                <p className="md:col-span-6 text-[#a3a3a3] text-base md:text-lg leading-relaxed">{m.body}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
